import { render } from "./BadgePrimary.vue?vue&type=template&id=02a0febc"
import script from "./BadgePrimary.vue?vue&type=script&lang=js"
export * from "./BadgePrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__